import { createFileRoute } from '@tanstack/react-router'
import { BotList, botListPersistence } from '@/features/bot/index.ts'

export const Route = createFileRoute('/_authenticated/system-management/bots/')({
  validateSearch: botListPersistence.validateSearch,
  beforeLoad: (options) => botListPersistence.restore(options),
  component: BotList
})
